import { render, staticRenderFns } from "./Channels.vue?vue&type=template&id=01f5f18c"
import script from "./Channels.vue?vue&type=script&lang=js"
export * from "./Channels.vue?vue&type=script&lang=js"
import style0 from "./Channels.vue?vue&type=style&index=0&id=01f5f18c&prod&lang=scss"
import style1 from "./Channels.vue?vue&type=style&index=1&id=01f5f18c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports